import { useRef, useState } from "react";

const FLASH_MS = 1500;

/** Destaque temporário verde/vermelho ao ativar/desativar um item — confirma a mudança visualmente
 *  por um instante, depois volta ao normal. Compartilhado por CatalogItemRow e a tabela de Materiais. */
export function useToggleFlash(onToggle?: (enabled: boolean) => void) {
  const [flash, setFlash] = useState<"green" | "red" | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  function handleToggle(checked: boolean) {
    onToggle?.(checked);
    setFlash(checked ? "green" : "red");
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setFlash(null), FLASH_MS);
  }

  return { flash, handleToggle };
}
